import { environment as CncfDevEnv } from '../../../../environments/cncf/environment.cncf-dev';
import { environment as CncfProdEnv } from '../../../../environments/cncf/environment.cncf-prod';
import { environment as CncfTestEnv } from '../../../../environments/cncf/environment.cncf-test';
import { environment as IgfSandboxEnv } from '../../../../environments/igf/environment.igf-dev';
import { environment as IgfDevEnv } from '../../../../environments/igf/environment.igf-dev-east';
import { environment as IgfProdEnv } from '../../../../environments/igf/environment.igf-prod';
import { environment as SinngeberDevEnv } from '../../../../environments/sinngeber/environment.sinngeber-dev';
import { environment as SinngeberProdEnv } from '../../../../environments/sinngeber/environment.sinngeber-prod';
import { environment as SinngeberTestEnv } from '../../../../environments/sinngeber/environment.sinngeber-test';
import { environment as FonteDevEnv } from '../../../../environments/fonte/environment.fonte-dev';
import { environment as FonteProdEnv } from '../../../../environments/fonte/environment.fonte-prod';
import { environment as FonteTestEnv } from '../../../../environments/fonte/environment.fonte-test';
import { environment as SwissDevEnv } from '../../../../environments/swiss/environment.swiss-dev';
import { environment as SwissProdEnv } from '../../../../environments/swiss/environment.swiss-prod';
import { CONTRIBUTION_TYPE } from '../../../_core/constants/Contribute';
import { ContributionType, RedirectTarget, TaxDeductionOption } from './donate-form.model';

export const TaxDeductionValues: TaxDeductionOption[] = [
  {
    code: true,
    value: 'Yes',
  },
  {
    code: false,
    value: 'No',
  },
];

export const ContributionTypes: ContributionType[] = [
  {
    code: CONTRIBUTION_TYPE.BANK_TRANSFER_ONLINE,
    displayName: 'contribute.contribution_type.bank_transfer_online',
  },
  {
    code: CONTRIBUTION_TYPE.BANK_TRANSFER_OFFLINE,
    displayName: 'contribute.contribution_type.bank_transfer_offline',
  },
  {
    code: CONTRIBUTION_TYPE.CREDIT_CARD,
    displayName: 'contribute.contribution_type.credit_card',
  },
  {
    code: CONTRIBUTION_TYPE.DONOR_ADVISED_FUND,
    displayName: 'contribute.contribution_type.donor_advised_fund',
  },
  {
    code: CONTRIBUTION_TYPE.PHYSICAL_CHECK,
    displayName: 'contribute.contribution_type.physical_check',
  },
  {
    code: CONTRIBUTION_TYPE.PUBLICLY_TRADED_SECURITIES,
    displayName: 'contribute.contribution_type.publicly_traded_securities',
  },
  {
    code: CONTRIBUTION_TYPE.OTHER_ASSETS,
    displayName: 'contribute.contribution_type.other_assets',
  },
  {
    code: CONTRIBUTION_TYPE.SEPA_DEBIT,
    displayName: 'contribute.contribution_type.sepa_debit',
  },
];

export enum PurchaseContributionType {
  PUBLIC_DONATE = 'PUBLIC_DONATE',
  PUBLIC_DONATE_BUTTON = 'PUBLIC_DONATE_BUTTON',
  PUBLIC_ASSESSMENT = 'PUBLIC_ASSESSMENT',
  PUBLIC_ASSESSMENT_BUTTON = 'PUBLIC_ASSESSMENT_BUTTON',
  PRIVATE = 'PRIVATE',
}

export enum DAF_PROVIDER {
  TRUSTBRIDGE = 'Trustbridge Global Foundation',
  IGF = 'International Generosity Foundation',
  GLF = 'Givers Legacy Foundation',
  OTHER = 'Other Donor Advised Fund',
}

export const RedirectTargets: RedirectTarget[] = [
  // SWISS
  {
    tenantId: SwissDevEnv.fund.tenantId,
    environmentUrl: SwissDevEnv.fund.url,
    name: SwissDevEnv.fund.environmentName,
  },
  {
    tenantId: SwissProdEnv.fund.tenantId,
    environmentUrl: SwissProdEnv.fund.url,
    name: SwissProdEnv.fund.environmentName,
  },
  // CNCF
  {
    tenantId: CncfDevEnv.fund.tenantId,
    environmentUrl: CncfDevEnv.fund.url,
    name: CncfDevEnv.fund.environmentName,
  },
  {
    tenantId: CncfTestEnv.fund.tenantId,
    environmentUrl: CncfTestEnv.fund.url,
    name: CncfTestEnv.fund.environmentName,
  },
  {
    tenantId: CncfProdEnv.fund.tenantId,
    environmentUrl: CncfProdEnv.fund.url,
    name: CncfProdEnv.fund.environmentName,
  },
  // IGF
  {
    tenantId: IgfDevEnv.fund.tenantId,
    environmentUrl: IgfDevEnv.fund.url,
    name: IgfDevEnv.fund.environmentName,
  },
  {
    tenantId: IgfSandboxEnv.fund.tenantId,
    environmentUrl: IgfSandboxEnv.fund.url,
    name: IgfSandboxEnv.fund.environmentName,
  },
  {
    tenantId: IgfProdEnv.fund.tenantId,
    environmentUrl: IgfProdEnv.fund.url,
    name: IgfProdEnv.fund.environmentName,
  },
  // SINNGEBER
  {
    tenantId: SinngeberDevEnv.fund.tenantId,
    environmentUrl: SinngeberDevEnv.fund.url,
    name: SinngeberDevEnv.fund.environmentName,
  },
  {
    tenantId: SinngeberTestEnv.fund.tenantId,
    environmentUrl: SinngeberTestEnv.fund.url,
    name: SinngeberTestEnv.fund.environmentName,
  },
  {
    tenantId: SinngeberProdEnv.fund.tenantId,
    environmentUrl: SinngeberProdEnv.fund.url,
    name: SinngeberProdEnv.fund.environmentName,
  },
  // FONTE
  {
    tenantId: FonteDevEnv.fund.tenantId,
    environmentUrl: FonteDevEnv.fund.url,
    name: FonteDevEnv.fund.environmentName,
  },
  {
    tenantId: FonteTestEnv.fund.tenantId,
    environmentUrl: FonteTestEnv.fund.url,
    name: FonteTestEnv.fund.environmentName,
  },
  {
    tenantId: FonteProdEnv.fund.tenantId,
    environmentUrl: FonteProdEnv.fund.url,
    name: FonteProdEnv.fund.environmentName,
  },
];
